import { instance } from "@/apis";
import { useMutation } from "@tanstack/react-query";

export const useCreateAiChatMemoMutation = () => {
  return useMutation({
    mutationFn: ({
      chatId,
      chatHistoryId,
    }: {
      chatId: string;
      chatHistoryId: string;
    }) => instance.post(`/api/df/user/chat/${chatId}/memo/${chatHistoryId}`),
  });
};
